<template>
  <div class="message">
    <div class="container">
      <el-page-header class="nav" @back="$router.go(-1)" content="我的消息">
      </el-page-header>
      <div class="message_box">
        <div class="one_message" v-for="item in messageList" :key="item.id">
          <div class="left">
            <p class="title_row">
              <span class="title">{{ item.title }}</span>
              <span class="time">{{ item.createTime }}</span>
            </p>
            <p class="content">{{ item.content }}</p>
          </div>
          <div class="right">
            <img
              src="@/assets/images/icons/icon_top.png"
              alt=""
              @click="setTop(item.id)"
            />
            <img
              src="@/assets/images/icons/icon_close.png"
              alt=""
              @click="
                showConfirm = true;
                delId = item.id;
              "
            />
          </div>
        </div>
      </div>
      <div class="foot_page">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :page-size="params.pageSize"
          :current-page.sync="params.pageNum"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>

    <confirm-dialog
      :show="showConfirm"
      @onConfirm="onConfirm"
      desc="确定要删除该条消息吗？"
    />
  </div>
</template>

<script>
import confirmDialog from "@/components/confirmDialog/index.vue";
export default {
  components: {
    confirmDialog,
  },
  data() {
    return {
      params: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 20,
      messageList: [
        {
          id: 1,
          title: "标题标题标题标题标题标题标题标题标题标题",
          content: "内容内容内容内容内容内容内容内容内容内容内容",
          createTime: "2021-07-23",
        },
        {
          id: 2,
          title: "标题标题标题标题标题标题标题标题标题标题",
          content: "内容内容内容内容内容内容内容内容内容内容内容",
          createTime: "2021-07-23",
        },
        {
          id: 3,
          title: "标题标题标题标题标题标题标题标题标题标题",
          content: "内容内容内容内容内容内容内容内容内容内容内容",
          createTime: "2021-07-23",
        },
      ],
      showConfirm: false,
      delId: null,
    };
  },
  methods: {
    // 置顶
    setTop(id) {},
    onConfirm(val) {
      if (val) {
        console.log("删除" + this.delId);
        this.delId = null;
      }
      this.showConfirm = false;
    },
    // 翻页
    pageChange() {},
  },
};
</script>

<style lang="less" scoped>
.message {
  background-color: rgb(248, 248, 248);
  ::v-deep .el-page-header {
    .el-page-header__content {
      font-size: 14px;
    }
  }
  .nav {
    margin: 40px 0;
  }
  .message_box {
    .one_message {
      padding: 20px;
      background-color: #fff;
      border-bottom: solid 1px #eee;
      overflow: hidden;

      .left {
        position: relative;
        float: left;
        padding-left: 25px;
        width: 90%;
        text-align: left;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 16px;
          height: 16px;
          background-color: #f90000;
          border-radius: 50%;
        }

        .title_row {
          margin-bottom: 5px;
          overflow: hidden;

          .title {
            float: left;
            line-height: 1;
            font-size: 16px;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.85);
          }

          .time {
            float: right;
            font-size: 16px;
            color: rgb(200, 200, 200);
          }
        }

        .content {
          font-size: 16px;
          color: rgb(200, 200, 200);
        }
      }

      .right {
        float: right;

        img {
          margin-left: 30px;
          width: 28px;
          height: 28px;
          cursor: pointer;
        }
      }
    }
  }

  ::v-deep .foot_page {
    margin-top: 30px;
    text-align: right;

    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #0d79ff;
    }

    .el-pagination__total {
      float: left;
    }
  }
}
</style>